/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactpersontype2Inputs */

const de__field_contactpersontype2 = /** @type {(inputs: _Field_Contactpersontype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt mit`)
};

/**

* @param {_Field_Contactpersontype2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contactpersontype2 = /** @type {((inputs?: _Field_Contactpersontype2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactpersontype2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contactpersontype2(inputs)
});
export { _field_contactpersontype2 as "_field_contactPersonType" }